import request from "../utils/request";

export async function getAll(payload) {
    return request.get("UserWant/GetAll", {
      params: {
        sortBy: payload.sortBy,
        sortDirection: payload.sortDirection,
        pageIndex: payload.pageIndex,
        pageSize: payload.pageSize,
        branchId: payload.branch != null || payload.branch != undefined ? payload.branch.id : null,
        startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
        startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
        endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
        endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
        status: payload.userWantStatus!=null ? payload.userWantStatus.id: null
      }
    });
  }

  export async function getAllAdmin(payload) {
    console.log(payload);
    return request.get("UserWant/GetAllAdmin",{
      params:{
        branchId: payload.branch != null || payload.branch != undefined ? payload.branch.id : null,
        userId: payload.personal != null || payload.personal != undefined ? payload.personal.id : null,
        startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
        startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
        endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
        endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null
      }
    });
  }

  export async function addUserWant(newUserWant){
    return request.post("UserWant/Add",newUserWant);
  }

  export async function getDetail(id) {
    return request.get("UserWant/Detail?id="+id);
  }

  export async function addComment(comment){
    return request.post("UserWant/AddComment",comment);
  }

  export async function changeStatus(status){
    return request.post("UserWant/ChangeStatus",status);
  }